import * as R from 'ramda';

import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';

import { getAttributeDataRows } from './collinsMpcUtilities';

import classes from './collinsMpcPdfReport.module.css';

interface Props {
  element: any;
}

const TopLevelElement = ({ element }: Props) => {
  const attributes = getAttributeDataRows(
    element?.attributes,
    R.pathOr([], ['attributeGroups', 0, 'attributes'], element),
  );

  return (
    <div className={classes.sectionBox}>
      <div className={classes.sectionTitle}>{element?.name}</div>
      <div className={classes.elementContent}>
        {attributes.map(attribute => {
          return (
            <div className={classes.dataRow} key={attribute?.id}>
              <div
                className={classes.attributeTitle}
              >{`${attribute?.name}:`}</div>
              <div className={classes.attributeContent}>
                {attributeDisplayUtility.display(
                  attribute.value,
                  attribute.dataType,
                  attribute.unit,
                  !!attribute.changeId,
                  attribute.newValue,
                  attribute.thousandsSeparator,
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopLevelElement;
